import Router from 'next/router';
import PropTypes from 'prop-types';
import {
  memo, useState, useRef, useEffect
} from 'react';

import NavItem from './components/NavItem';
import {
  NavigationWrapperStyled,
  NavigationStyled,
  SearchInputStyled,
  SearchWrapperStyled,
  ClearBtnStyled,
  CloseStyled,
  SearchBtnStyled,
  SearchMenuBtnStyled,
  MagnifyGlassStyled
} from './styled/NavigationStyled';

const propTypes = {
  category: PropTypes.string,
  className: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string
  })).isRequired,
  noSearchBar: PropTypes.bool,
  pageName: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired
};

const Navigation = ({
  data, path, category, className, pageName, noSearchBar
}) => {
  const subCategoryNavData = data.map(({ name, slug }) => ({
    name,
    active: category === slug,
    href: `/${path}/${slug}`
  }));

  const formattedNavData = [
    {
      name: pageName,
      href: `/${path}`
    },
    ...subCategoryNavData
  ];

  const searchRef = useRef();
  const [termValue, setTermValue] = useState('');
  const [showSearch, setShowSearch] = useState(false);

  useEffect(() => {
    if (!noSearchBar && showSearch) searchRef.current.focus();
  }, [noSearchBar, showSearch]);

  const searchInputOnChange = (searchTerm) => {
    setTermValue(searchTerm);
  };

  const searchInputClear = (searchTerm) => {
    setTermValue(searchTerm);
    setShowSearch(false);
  };

  const onSearch = (value) => Router.push(`/${path}/search/${value}`);

  const handleKeyUp = (e) => {
    if (e.key === 'Enter') {
      onSearch(termValue);
    }
  };

  return (
    <NavigationWrapperStyled className={className}>
      <NavigationStyled>
        { !showSearch && formattedNavData.map(({ name, active, href }) => (
          <NavItem
            key={name}
            active={active}
            name={name.replace(/&amp;/g, '&')}
            href={href}
          />
        ))}
        {!noSearchBar && !showSearch && (
        <SearchMenuBtnStyled>
          <MagnifyGlassStyled onClick={() => setShowSearch(true)} />
        </SearchMenuBtnStyled>
        )}
      </NavigationStyled>
      {!noSearchBar
        && showSearch && (
        <SearchWrapperStyled>
          <SearchInputStyled
            onChange={(e) => searchInputOnChange(e.target.value.replace('<', '').replace('>', ''))}
            value={termValue.replace('<', '').replace('>', '')}
            placeholder="Search posts"
            onKeyUp={handleKeyUp}
            ref={searchRef}
          />
          <SearchBtnStyled>
            <MagnifyGlassStyled />
          </SearchBtnStyled>
          <ClearBtnStyled onClick={() => searchInputClear('')}>
            <CloseStyled />
          </ClearBtnStyled>
        </SearchWrapperStyled>
      )}
    </NavigationWrapperStyled>
  );
};

Navigation.propTypes = propTypes;

Navigation.defaultProps = {
  className: '',
  category: '',
  noSearchBar: false
};

export default memo(Navigation);
